import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/ChangePasswordDef';

const autoGenerateSuccess = (password: string) => {
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Senha Alterada com Sucesso',
      message: 'Senha Alterada com Sucesso',
    },
    configRequest: {
      method: 'PUT',
      path: ENDPOINT_API_PATH,
      body: {
        password,
      },
    },
    configResponse: {
      status: 200,
      data: {},
      headers: {},
    },
  };
  return validateDocumentSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess(MocksDef.PASSWORD);

const generatedSuccessMocks = [autoGenerateSuccessToken];

const autoGenerate = (password: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const body = {
        password: `${password.slice(0, -1)}${index}`,
      };
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'PUT',
          path: ENDPOINT_API_PATH,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate(MocksDef.PASSWORD);
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const CreateMember = [...generatedSuccessMocks, ...errorsGenerated];
export default CreateMember;
